module.exports = __webpack_public_path__ + "static/media/SectionPartners_youngwoo_digital.9831ee96.png";